<template>
  <section class="premium-edit">

    <div class="premium-container">
      <div class="box">
        <h4>Previous Remaining Premium</h4>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Percentage</span>
            <span>Amount</span>
          </div>
          <div class="tr">
            <span>Basic Premium</span>
            <span>-</span>
            <span>{{ oldForm.pre_basic_prm | formatMoney(2, true) }}</span>
            <!-- <span>{{ formData.base_prm | formatMoney(2, true) }}</span> -->
          </div>
          <div class="tr">
            <span>Client Discount</span>
            <span>{{ oldForm.srd_pct }}%</span>
            <span>{{ oldForm.srd_amt | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Loading</span>
            <span>{{ oldForm.loading_pct }}%</span>
            <span>{{ oldForm.loading_amt | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>NCD</span>
            <span>{{ oldForm.ncd_pct }}%</span>
            <span>{{ oldForm.ncd_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>MGM Discount</span>
            <span>-</span>
            <span>{{ oldForm.code_disc_prm | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>MIB</span>
            <span>{{ oldForm.mib_pct }}%</span>
            <span>{{ oldForm.mib_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Levy</span>
            <span>{{ oldForm.ia_levy_pct }}%</span>
            <span>{{ oldForm.ia_levy_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Manual Discount</span>
            <span>{{ oldForm.spec_disc_pct }}%</span>
            <span>{{ oldForm.spec_disc_prm | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Total Premium</span>
            <span>-</span>
            <span>{{ oldForm.payable | formatMoney(2, true) }}</span>
          </div>
        </div>
      </div>
      <el-form
        ref="premium-form"
        :model="premiumForm"
        :rules="rules">
        <div class="box">
          <h4>New Remaining Premium</h4>
          <div
            class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Amount</span>
            </div>

            <template v-if="productId == 15">
              <div class="tr">
                <span>
                  Section I - Material Damage Premium
                  <br />
                  <el-form-item prop="mat_dam_prm">
                    <v-input
                      v-model="premiumForm.mat_dam_prm"
                      prepend="$"
                      @blur="handlerGetQuoteMain"
                      @keyEnter="handlerGetQuoteMain" />
                  </el-form-item>
                </span>
              </div>
              <div class="tr">
                <span>
                  Section II - 3rd Party Liability Premium
                  <br />
                  <el-form-item prop="tppd_limit_prm">
                    <v-input
                      v-model="premiumForm.tppd_limit_prm"
                      prepend="$"
                      @blur="handlerGetQuoteMain"
                      @keyEnter="handlerGetQuoteMain" />
                  </el-form-item>
                </span>
              </div>
            </template>

            <div
              v-else
              class="tr">
              <span>
                Basic Premium
                <br/>
                <el-form-item
                  v-if="productId == 11"
                  prop="base_prm">
                  <v-input
                    v-model="premiumForm.base_prm"
                    prepend="$"
                    @blur="handlerGetQuoteMain"
                    @keyEnter="handlerGetQuoteMain"/>
                </el-form-item>
                <el-form-item
                  v-else
                  prop="basic_prm">
                  <v-input
                    v-model="premiumForm.basic_prm"
                    prepend="$"
                    @blur="handlerGetQuoteMain"
                    @keyEnter="handlerGetQuoteMain"/>
                </el-form-item>
              </span>
              <span>{{ productId == 11? premiumForm.base_prm: premiumForm.basic_prm | formatMoney(2, true) }}</span>
            </div>

            <template v-if="productId == 11">
              <div class="tr">
                <span>
                  Client Discount
                  <br/>
                  <el-form-item prop="srd_pct">
                    <v-input
                      v-model="premiumForm.srd_pct"
                      append="%"
                      @blur="handlerGetQuoteMain"
                      @keyEnter="handlerGetQuoteMain"/>
                  </el-form-item>
                </span>
                <span>{{ premiumForm.srd_amt | formatMoney(2, true) }}</span>
              </div>
              <div class="tr">
                <span>Loading
                  <br/>
                  <el-form-item prop="loading_pct">
                    <v-input
                      v-model="premiumForm.loading_pct"
                      append="%"
                      @blur="handlerGetQuoteMain"
                      @keyEnter="handlerGetQuoteMain"/>
                  </el-form-item>
                </span>
                <span>{{ premiumForm.loading_amt | formatMoney(2, true) }}</span>
              </div>
              <div class="tr">
                <span>NCD
                  <br/>
                  <el-form-item prop="cfd_pct">
                    <v-input
                      v-model="premiumForm.cfd_pct"
                      append="%"
                      @blur="handlerGetQuoteMain"
                      @keyEnter="handlerGetQuoteMain"/>
                  </el-form-item>
                </span>
                <span>{{ premiumForm.cfd_amt | formatMoney(2, true) }}</span>
              </div>
            </template>

            <!-- <div class="tr">
            <span>
              Client Discount
              <br/>
              <v-input
                v-model="premiumForm.srd_pct"
                append="%"
                @blur="handlerGetQuoteMain"
                @keyEnter="handlerGetQuoteMain"/>
            </span>
            <span>{{ premiumForm.srd_amt | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Loading
              <br/>
              <v-input
                v-model="premiumForm.loading_pct"
                append="%"
                @blur="handlerGetQuoteMain"
                @keyEnter="handlerGetQuoteMain"/>
            </span>
            <span>{{ premiumForm.loading_amt | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>NCD
              <br/>
              <v-input
                v-model="premiumForm.cfd_pct"
                append="%"
                @blur="handlerGetQuoteMain"
                @keyEnter="handlerGetQuoteMain"/>
            </span>
            <span>{{ premiumForm.cfd_amt | formatMoney(2, true) }}</span>
          </div> -->
            <div
              v-if="showECLevy"
              class="tr">
              <span>Employee Compensation Premium
                <br/>
                <el-form-item prop="ec_levy_prm">
                  <v-input
                    v-model="premiumForm.ec_levy_prm"
                    @blur="handlerGetQuoteMain"
                    @keyEnter="handlerGetQuoteMain"/>
                </el-form-item>
              </span>
              <span>{{ premiumForm.ec_levy_prm | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>MGM Discount
                <br/>
                <el-form-item prop="code_disc_pct">
                  <v-input
                    v-model="premiumForm.code_disc_pct"
                    append="%"
                    @blur="handlerGetQuoteMain"
                    @keyEnter="handlerGetQuoteMain"/>
                </el-form-item>
              </span>
              <span>{{ premiumForm.code_disc_prm | formatMoney(2, true) }}</span>
            </div>

            <div
              v-if="productId == 11"
              class="tr">
              <span>MIB</span>
              <span>{{ premiumForm.mib_pct }}%</span>
              <span>{{ premiumForm.mib_vl | formatMoney(2, true) }}</span>
            </div>
            <div
              v-if="showECLevy"
              class="tr">
              <span>EC Levy</span>
              <span>{{ premiumForm.ec_levy_pct }}%</span>
              <span>{{ premiumForm.ec_levy_vl | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>Promo Discount</span>
              <span>{{ premiumForm.promo_disc_pct }}%</span>
              <span>{{ premiumForm.promo_disc_prm | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>IA Levy</span>
              <span>{{ premiumForm.ia_levy_pct }}%</span>
              <span>{{ premiumForm.ia_levy_vl | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>Manual Discount
                <br/>
                <el-form-item prop="spec_disc_prm">
                  <v-input
                    v-model="premiumForm.spec_disc_prm"
                    append="HK$"
                    @blur="handlerGetQuoteMain"
                    @keyEnter="handlerGetQuoteMain"/>
                </el-form-item>
              </span>
              <span>{{ premiumForm.spec_disc_prm | formatMoney(2, true) }}</span>
            </div>
            <div class="tr">
              <span>Total Premium</span>
              <span>{{ premiumForm.payable | formatMoney(2, true) }}</span>
            </div>
          </div>
        </div>
      </el-form>
      <div class="box">
        <h4>Difference Payable</h4>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Amount</span>
          </div>
          <div class="tr">
            <span>Pre-adjustment Premium</span>
            <span>{{ formData.payable | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Post-adjustment Premium</span>
            <span>{{ premiumForm.payable | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Admin Charge
              <br/>
              <v-input
                v-model="handlingFee"
                prepend="$"/>
            </span>
            <span>{{ handlingFee | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Payable</span>
            <span>{{ payable | formatMoney(2, true) }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import OMath from '@/utils/math'
import {getQuoteMain} from '@/api/endorsement'

export default {
  name: 'PremiumEdit',
  mixins: [MixinFormat, MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    oldForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {},
      handlingFee: '',
      premiumForm: {
        base_prm: '',
        basic_prm: '',
        srd_pct: '',
        srd_amt: '',
        loading_amt: '',
        loading_pct: '',
        cfd_pct: '',
        cfd_amt: '',
        code_disc_pct: '',
        code_disc_prm: '',
        mib_pct: '',
        mib_vl: '',
        ia_levy_pct: '',
        ia_levy_vl: '',
        spec_disc_pct: '',
        spec_disc_prm: '',
        payable: '',
        // handling_fee: '',
        // 裝修工程
        ec_levy_pct: '',
        ec_levy_prm: '',
        ec_levy_vl: '',
        mat_dam_prm: '',
        tppd_limit_prm: '',
        // 優惠券
        promo_disc_pct: '',
        promo_disc_prm: '',
      },
      oldPremiumForm: {
        base_prm: '',
        basic_prm: '',
        srd_pct: '',
        loading_pct: '',
        cfd_pct: '',
        code_disc_pct: '',
        spec_disc_pct: '',
        // handling_fee: '',
        spec_disc_prm: '',
        // 裝修工程
        ec_levy_prm: '',
        mat_dam_prm: '',
        tppd_limit_prm: '',
      }
    }
  },
  computed: {
    payable() {
      const prePayable = Number(this.formData.payable)
      const postPayable = Number(this.premiumForm.payable)
      const handlingFee = Number(this.handlingFee)
      return OMath.round(postPayable + handlingFee - prePayable)
    },
    productId() {
      return this.form.product_id || 11
    },
    showECLevy() {
      const { ec_levy_pct } = this.premiumForm
      return this.productId == 15 && ec_levy_pct > 0
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
        Object.keys(this.premiumForm).some(key => {
          if (key in val) {
            this.premiumForm[key] = val[key]
          }
          if (key == 'cfd_pct') {
            this.premiumForm['cfd_pct'] = val['ncd_pct']
          }
          if (key == 'cfd_amt') {
            this.premiumForm['cfd_amt'] = val['ncd_vl']
          }
        })
        this.handlingFee = 0
        this.handlerGetQuoteMain()
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs['premium-form'].validate(valid => {
        if(valid) {
          this.$emit('submit', {
            ...this.premiumForm,
            handling_fee: this.handlingFee,
            difference: this.payable // 計算是否需要退款用
          })
        }
      })

    },
    handlerGetQuoteMain() {
      // const {
      //   base_prm = '', basic_prm = '', srd_pct = '', loading_pct = '',
      //   cfd_pct = '', code_disc_pct = '', spec_disc_pct = '', handling_fee = '', spec_disc_prm = ''
      // } = this.premiumForm
      // 檢查是否爲空
      // const check = this.handler().checkParams({
      //   base_prm,
      //   basic_prm,
      //   srd_pct,
      //   loading_pct,
      //   cfd_pct,
      //   code_disc_pct,
      //   // spec_disc_pct,
      //   handling_fee,
      //   spec_disc_prm
      // })
      const checked = this.handler().checkParams()
      if (checked) {
        this.network().getQuoteMain()
      }
    },
    // inputHandlingFee(val) {
    //   const value = OMath.round(val)
    //   const prePayable = OMath.round(this.formData.payable)
    //   const postPayable = OMath.round(this.premiumForm.payable)

    // },
    handler() {
      return {
        checkParams: () => {
          let flag = true // 標記是否有空
          let different = false // 標記是否存在不同的數值

          // let premiumForm = JSON.parse(JSON.stringify(this.premiumForm))
          // if(this.productId != 11) {
          //   delete premiumForm.base_prm
          //   delete premiumForm.srd_pct
          //   delete premiumForm.loading_pct
          //   delete premiumForm.cfd_pct
          // }
          // else {
          //   delete premiumForm.basic_prm
          // }
          const {
            base_prm,
            basic_prm,
            srd_pct,
            loading_pct,
            cfd_pct,
            code_disc_pct,
            spec_disc_prm,
            // handling_fee
            ec_levy_prm,
            mat_dam_prm,
            tppd_limit_prm,
          } = this.premiumForm
          let premiumForm = {
            code_disc_pct,
            spec_disc_prm,
            // handling_fee
          }
          if(this.productId == 11) {
            premiumForm = {
              ...premiumForm,
              base_prm,
              srd_pct,
              loading_pct,
              cfd_pct
            }
          }
          else {
            premiumForm = {
              ...premiumForm,
              basic_prm
            }
          }

          if(this.showECLevy) {
            premiumForm = {
              ...premiumForm,
              ec_levy_prm,
              mat_dam_prm,
              tppd_limit_prm
            }
          }



          Object.keys(premiumForm).some(key => {
            const value = this.premiumForm[key]
            if (String(value).trim() === '') {
              flag = false
              return true
            }
            if (value !== this.oldPremiumForm[key]) {
              different = true
            }
            console.log(value, this.oldPremiumForm[key], '==', key)
          })
          if (!flag || !different) {
            console.log('no different')
            return false
          }
          return true
        }
      }
    },
    network() {
      return {
        getQuoteMain: async () => {
          const {company_id, class_id, trm_of_cvr} = this.formData
          const {data} = await getQuoteMain({
            ...this.premiumForm,
            handling_fee: 0,
            company_id,
            class_id,
            trm_of_cvr,
          })
          this.premiumForm = Object.assign(this.premiumForm, data)
          // 記錄一下 premium 值
          Object.keys(this.oldPremiumForm).some(key => {
            this.oldPremiumForm[key] = this.premiumForm[key]
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.premium-edit {
  .premium-container {
    display: flex;

    & > .box {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }

    .box {
      flex: 1;
    }
  }
}
</style>
